import React, {useContext, useEffect, useState} from 'react';
import { FormContext, MDForm } from '../../metadata/MDForm';
import _ from 'lodash';
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import { ModelContext } from '../../metadata/ModelSource';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import {DownOutlined, RightOutlined} from "@ant-design/icons";
import { Checkbox, Collapse } from 'antd';
import { PremiumSum } from '../../PremiumSum';
import { Field } from '../../metadata/Field';
import { ApplicationExtendedAttributes } from '../ApplicationForm';
import { DeclaredComponent, DynamicComponent } from '../../DynamicComponent';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { getLineProductSetupContext } from '../line/LineForm';
import { getRiskProductSetupContext } from '../risk/RiskListForm';
import { getDefaultValue } from '../../metadata/metadata';
import { coerceToBoolean } from '../../metadata/coercer';
import {TooltipHint} from '../../metadata/TooltipHint';

export function CoverageField({
                                attr: attrId,
                                checkedAttr,
                                placeHolderText,
                                isOptional,
                                coverageCd,
                                attr,
                                hintText,
                                lineCd,
                                riskTypeCd,
                                showCheckbox,
                                form,
                                dynamicCoverage,
                                label,
                                dataType,
                                ...props
                              }) {
  let displayCheckbox = typeof showCheckbox === "undefined" ? true : showCheckbox;
  let COUNTER = 0;
  const [domId] = useState(() => `${attrId}:${COUNTER++}`);
  const [isExpanded, setExpanded] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const formContext = useContext(FormContext);
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);
  const { isDesktop, isMobile, isTablet } = useContext(GlobalStateContext);
  const [isChecked, setChecked] = useState(isOptional ? false : true);

  useEffect(() => {
    if (checkedAttr) {
      let checked = formContext.getValueByAttr(checkedAttr);

      // get metadata attribute
      const metaAttr = formContext.metadata[checkedAttr];
      let defaultVal = undefined;

      // check if there are default values

      if (metaAttr && checked === undefined) {
        defaultVal = getDefaultValue(metaAttr);
        if (defaultVal !== undefined) {
          formContext.setValueByAttr(checkedAttr, defaultVal);
        }
      }

      // convert default val to
      if(checked) {
        checked = coerceToBoolean(checked);
      } else {
        checked = coerceToBoolean(defaultVal);
      }
      setChecked(checked ? checked : false);
    } else if (! dynamicCoverage && attr) {
      // This is not a dynamic coverage and therefore the coverage is tied to a metadata attribute
      const limitValue = formContext.getValueByAttr(attr);
      setChecked(limitValue ? true : false);
      if (!isOptional) {
        // If the defined coverage is not optional, then we set the default value to true
        setChecked(true);
      }
      if (isChecked) {
        setExpanded(true);
      }
    } else if (dynamicCoverage && attr) {
      // This is a dynamic coverage and therefore is associated to a complex coverage model
      const coveragePrefix = `coverages{coverageCd:${coverageCd}}`;
      const coverageModel = formContext.getValue(coveragePrefix);
      if (coverageModel && coverageModel.status === 'Active') {
        setChecked(true);
      }
    }
  }, []);

  if (!label) {
    label = attr.label;
  }

  if (attr && attr.requiredInd) {
    label = (
        <>
          {label} <span>*</span>
        </>
    );
  }

  const setCheckedValue = (checked) => {
    if (checkedAttr) {
      formContext.setValueByAttr(checkedAttr, checked);
    }
  };

  const setCoverageStatus = (coverageCd, status) => {
    const statusField = `coverages{coverageCd:${coverageCd}}.status`;
    formContext.setValue(statusField, status);
  }

  const displayFieldImp = () => {
    if (isChecked) {
      setChecked(false);
      setCheckedValue(false);
      setDisabled(true);
      if (typeof attr === 'string') {
        const metaAttr = formContext.metadata[attr];
        if (metaAttr.dataType === 'Boolean') {
          formContext.setValueByAttr(attrId, false);
        } else if (metaAttr.dataType === 'Integer') {
          formContext.setValueByAttr(attrId, 0);
        } else {
          formContext.setValueByAttr(attrId, "");
        }
      } else {
        if (attr) {
          setCoverageStatus(coverageCd, 'Deleted');
        }
      }
      setExpanded(false);
    } else {
      setChecked(true);
      setCheckedValue(true);
      setDisabled(false);
      if (typeof attr !== 'string') {
        if (attr) {
          setCoverageStatus(coverageCd, 'Active');
        }
      }
      setExpanded(true);
    }
  };

  const displayIcon = () => {
    return (
      <Checkbox
        style={{marginLeft: '1em', marginBottom: '1em'}}
        defaultChecked={!isOptional}
        disabled={!isOptional}
        onChange={() => displayFieldImp()}
        checked={isChecked}
    />
    );
  };
  const lineProductSetupContext = getLineProductSetupContext(
      productSetup,
      applicationModel,
      lineCd
  );

  const riskProductSetupContext = riskTypeCd !== undefined ? getRiskProductSetupContext(lineProductSetupContext, riskTypeCd) : null;

  const coveragePrefix = `coverages{coverageCd:${coverageCd}}`;
  const limit1Attr = !_.isEmpty(attr && attr.attributeMetadata) && attr.attributeMetadata["Limit1.Value"] ? attr.attributeMetadata["Limit1.Value"] : null;
  let LineField = "";
  if(limit1Attr){
    limit1Attr.attr = limit1Attr.id;
    LineField = (
        <MDForm
            model={applicationModel}
            prefix={coveragePrefix}
            productSetupContext={attr}
            presentationMetadata={{Field: {attr: limit1Attr.id, metadata: limit1Attr, rawField: true, isChecked}}}
            extendedAttributes={ApplicationExtendedAttributes}
        >
          <DeclaredComponent declaration={{Field: {attr: limit1Attr.id, metadata: limit1Attr, rawField: true, isChecked, showTopLabel: true }}} />
        </MDForm>
    )
  } else if(attr && typeof attr !== "object") {
    if (isDesktop) {
      LineField = (
          <MDForm
              model={applicationModel}
              productSetupContext={formContext.productSetupContext}
              presentationMetadata={{Field: {attr: attr}}}
              extendedAttributes={ApplicationExtendedAttributes}
          >
            <DeclaredComponent declaration={{Field: {attr: attr, showTopLabel: false }}} />
          </MDForm>
      )
    } else {
      const labelText = ((dataType === 'Boolean') ? 'Add coverage?' : 'Amount Desired');
      LineField = (
          <Field attr={attr} isChecked={isChecked} disabled={isDisabled} showTopLabel={true} label={labelText} style={{ width: '180px'}}/>
      )
    }
  }
  let LeadSectionDesktop = (
      <React.Fragment>
        <Col span={1}>
          {form && (
            isExpanded
              ? <DownOutlined onClick={() => setExpanded(!isExpanded)} />
              : <RightOutlined onClick={() => setExpanded(!isExpanded)} />
          )}
        </Col>
        <Col span={displayCheckbox ? 9 : 15}>
          <label htmlFor={domId}>
            <strong>
              {label}
              {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
            </strong>
          </label>
          <div>{placeHolderText}</div>
        </Col>
        <Col span={6}>
          {isChecked ? LineField : ''}
        </Col>
      </React.Fragment>
  );
  let LeadSectionMobile = (
      <React.Fragment>
        <Col span={1} style={{paddingLeft: '5px', paddingRight: '20px' }}>
          {form && (
            isExpanded
              ? <DownOutlined onClick={() => setExpanded(!isExpanded)} />
              : <RightOutlined onClick={() => setExpanded(!isExpanded)} />
          )}
        </Col>
        <Col span={displayCheckbox ? 15 : 20}>
          <label htmlFor={domId}>
            <strong>
              {label}
              {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
            </strong>
          </label>
          <div>{placeHolderText}</div>
        </Col>
        <Col span={1}>
          {''}
        </Col>
      </React.Fragment>
  );

  const prodSetupContext = riskProductSetupContext ? riskProductSetupContext : attr;
  return (
      <React.Fragment>
        <Row style={{ display: 'flex', width: '100%', margin: '20px 0' }}>
          {displayCheckbox && <Col span={3}>{displayIcon()}</Col>}
          {isDesktop ? LeadSectionDesktop : LeadSectionMobile}
          <Col span={5}>
            { attr || checkedAttr ? <PremiumSum attr={attr} cd={coverageCd} /> : "--" }
          </Col>
        </Row>
        {!isDesktop &&
        <Row style={{ display: 'flex', width: '100%', margin: '20px 0' }}>
          <Col span={20} offset={3}>
            {isChecked ? LineField : ''}
          </Col>
        </Row>
        }
        {isChecked && form && form.Group && (
            <Row
                style={{
                  display: isExpanded ? 'block': 'none',
                  transition: 'all 0.2s ease-in-out',
                }}
            >
              <Col span={isDesktop ? 16 : 20} offset={isDesktop ? 4 : 3}>
                <MDForm
                    model={applicationModel}
                    prefix={dynamicCoverage ? coveragePrefix : ''}
                    productSetupContext={prodSetupContext}
                    presentationMetadata={form}
                    extendedAttributes={ApplicationExtendedAttributes}
                >
                  <DeclaredComponent declaration={form} />
                </MDForm>
              </Col>
            </Row>
        )}
      </React.Fragment>
  );
}

